// extracted by mini-css-extract-plugin
export var products = "index-module--products--h3vtd";